import { create } from 'zustand';
import { persist, createJSONStorage } from "zustand/middleware";

interface ModalState {
    checked: boolean
    setChecked: (v: boolean) => void
    _hasHydrated?: boolean;
}


export const useModalState = create<ModalState>()(
    persist(
        (set) => ({
            checked: false,
            setChecked: (checked: boolean) => {
                set({checked})
            },
        }),
        {
            name: "modal-state-v1",
            version: 1,
            storage: createJSONStorage(() => localStorage),
            partialize: (s) => ({ checked: s.checked }),
        }
    )
)